import * as React from 'react'
import BookingSuccess from '../../components/Scheduling/Booker/BookingSuccess'
import { browserTimezone } from '../../components/Scheduling/Booker/format'
import { PublicBooking } from '../../types'

export default function BookingPage({ booking, embed }: { booking: PublicBooking, embed: boolean }) {
  return (
    <div className='mx-auto w-full max-w-2xl'>
      <BookingSuccess booking={booking} timezone={browserTimezone()} embedded={embed} />
    </div>
  )
}
